import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-image-library',
  templateUrl: './image-library.component.html',
  styleUrls: ['./image-library.component.scss']
})
export class ImageLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
